<template>
  <div class="main-conent main-conent-minheight home-preview">
    <el-card shadow="never" class="border-none search">
      <search
        slot="header"
        :day="day"
        :date-count="dateCount"
        :loading-count="loadingCount"
        @change="goSearch"
        @month-change="_getDateCount"
        @date-change="dayChange"
      ></search>

      <img-cards
        :data="data"
        :loading="loading"
        @show-model="showModel"
      ></img-cards>
    </el-card>
  </div>
</template>

<script>
import showScannerDetail from '@/views/Telemetry/images/model'
import ImgCards from './cards'
import Search from './Search'
import { getDateCount } from '@/service/telemetry'
import { imgs as getImgs } from '@/service/admin/preview'
import { formatDate, add } from '@/utlis/date'
import _ from 'lodash'
import sleep from '@/utlis/sleep'

export default {
  components: { Search, ImgCards },
  data() {
    return {
      loading: false,
      loadingCount: false,
      day: '',
      data: [],
      dateCount: [],
      dev: {}
    }
  },
  methods: {
    async getData(query = {}, devChange) {
      this.loading = true
      if (!query.day) query.day = 'lastDay'

      const [{ data }] = await Promise.all([getImgs(query), sleep(1)])
      const { pictures, insects } = data
      this.data = _.orderBy(
        pictures.map(p => ({
          ...p,
          insects: insects.filter(i => i.pictureId === p.id && i.qty > 0)
        })),
        'createdAt',
        'desc'
      )

      if (query.day === 'lastDay') {
        let im = pictures && pictures[0] ? pictures[0].createdAt : undefined
        this.day = this.initDay(im)
      }

      if (devChange) {
        this._getDateCount(formatDate(this.day, 'YYYY-MM'))
      }
      this.loading = false
    },
    async _getDateCount(month) {
      this.month = month
      this.loadingCount = true
      const [{ data }] = await Promise.all([
        getDateCount(this.dev.id, month, this.dev.company),
        sleep(0.5)
      ])
      this.loadingCount = false
      this.dateCount = data
    },
    async dayChange(day) {
      this.day = day
      this.page = 1
      let query = this.getQuery(day, this.page)
      this.getData(query)
    },
    initDay(_date) {
      const createdAt = _date ? new Date(_date) : new Date()
      const hour = createdAt.getHours()
      if (hour >= 8) {
        return add(createdAt, 1, 'days', 'YYYY-MM-DD')
      } else {
        return formatDate(createdAt, 'YYYY-MM-DD')
      }
    },
    goSearch(dev) {
      this.dev = dev
      let query = this.getQuery('lastDay', 1)
      this.getData(query)
    },
    getQuery(day) {
      return {
        day,
        page: 1,
        limit: 100,
        companyId: this.dev.company,
        keys: this.dev.key
      }
    },
    showModel(id) {
      let query = this.getQuery()
      showScannerDetail({ id, query: { ...query, limit: 1 } })
    }
  }
}
</script>

<style lang="css">
.home-preview {
  height: 100%;
}
.home-preview .el-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home-preview .el-card__body {
  flex: 1;
  background-color: #f2f6fc;
  overflow: auto;
}
</style>
